import { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link, Location, useLocation } from 'react-router';

import css from './Layout.module.css';

export function LayoutBackButton({
  children,
  fallbackTo,
}: {
  children: ReactNode;
  fallbackTo: string | Location;
}) {
  const location = useLocation();
  const to = location?.state?.back || fallbackTo;

  return (
    <Link className={css.back} to={to}>
      <div className={css.backIcon}>
        <ArrowLeft />
      </div>
      {children}
    </Link>
  );
}
